import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from '../env.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  apiURL;
  constructor(private http: HttpClient, envService: EnvService) {
    this.apiURL = envService.API_URL;
  }
  getUser(id: string) {
    const apiUrl = this.apiURL + 'user/' + id.toString();
    return this.http.get(apiUrl);
  }
  getUserByUsername(username: string) {
    const apiUrl = this.apiURL + 'user/username/' + username;
    return this.http.get(apiUrl);
  }
  getUserPromotions(userId: string) {
    const apiUrl = this.apiURL + 'user/' + userId + '/promotions';
    return this.http.get(apiUrl);
  }
}
